import { SafeJSON } from './../../shared/safe-json';
import * as moment from 'moment';
import { AllegationResult } from './../juvenile-case-sections/allegation-result';
import { AllegationUndisciplined } from './../juvenile-case-sections/allegation-undisciplined';
import { ContemptMotion } from './../juvenile-case-sections/contempt-motion';
import { DispositionResult } from './../juvenile-case-sections/disposition-result';
import { DispositionDelinquentOffense } from './../juvenile-case-sections/disposition-delinquent-offense';
import { DispositionUndisciplined } from './../juvenile-case-sections/disposition-undisciplined';
import { RelatedParty } from './../juvenile-case-sections/related-party';
import { RelatedEvent } from './../juvenile-case-sections/related-event';
import { ProbationCondition } from './../juvenile-case-sections/probation-condition';
import { SupplementalDisposition } from './../juvenile-case-sections/supplemental-disposition';

export class Allegations {
    private json: any;
    private key: string;
    private transfrdCounty: string;
    private transfrdCase: string;
    private transfrdDate: string;
    private transfrdTime: string;
    private relatedParties: any = [];
    private allegationResult: AllegationResult;
    private allegationUndisciplined: AllegationUndisciplined;
    private allegationContemptMotion: ContemptMotion;
    private dispositionContemptMotion: ContemptMotion;
    private dispositionResult: DispositionResult;
    private dispositionDelinquentOffense: DispositionDelinquentOffense;
    private dispositionUndisciplined: DispositionUndisciplined;
    private supplementalDispositions: any = [];
    private probationCondition: ProbationCondition;
    private relatedEvents: any = [];

    private allegationResultFlag = false;
    private dispositionResultFlag = false;
    private supplDispositionFlag = false;
    private probationConditionFlag = false;
    private relatedEventsFlag = false;
    private relatedPartiesFlag = false;


    // constructor(json: any, key: string, transfrdCounty: string, transfrdCase: string, transfrdDate: string, transfrdTime: string) {
    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
        // this.transfrdCounty = transfrdCounty;
        // this.transfrdCase = transfrdCase;
        // this.transfrdDate = transfrdDate;
        // this.transfrdTime = transfrdTime;

        this.populateAllegationResult();
        this.populateAllegationUndisciplined();
        this.populateRelatedPartyList();
        this.populateAllegationContemptMotion();
        this.populateDispositionContemptMotion();
        this.populateDispositionResult();
        this.populateDispositionDelinquentOffense();
        this.populateDispositionUndisciplined();
        this.populateRelatedEvents();
        this.populateProbationConditons();
        this.populateSupplementalDispositions();
    }

    getIndex(): string {
        return this.key;
    }

    getTransfrdCounty(): string {
        return SafeJSON.get('fromJuvenilePleading.transferFromCounty', this.json);
    }

    getTransfrdCase(): string {
        return SafeJSON.get('fromJuvenilePleading.transferFromCase', this.json);
    }

    getTransfrdDate(): string {
        return SafeJSON.get('fromJuvenilePleading.pleadingDate', this.json);
    }

    getTransfrdTime(): string {
        return SafeJSON.get('fromJuvenilePleading.pleadingTime', this.json);
    }

    getAdjudicationType(): string {
        let disType = '';
        let adjudicationDisposition: any = SafeJSON.get('adjudicationDisposition', this.json);

        if (adjudicationDisposition === '' || adjudicationDisposition === undefined || adjudicationDisposition === null) {
            disType = 'MC';
        }

        let obj: any = SafeJSON.get('adjudicationDisposition.adjudications', this.json);

        for (const temp of obj) {
            disType = SafeJSON.get('adjudicationType', temp);
        }

        switch (disType) {
            case 'D': return disType;
            case 'U': return disType;
            case 'MC': return disType;
            default: return 'D';
        }
    }

    getDispositionType(): string {
        let disType = '';

        let adjudicationDisposition: any = SafeJSON.get('adjudicationDisposition', this.json);

        if (adjudicationDisposition === '' || adjudicationDisposition === undefined || adjudicationDisposition === null) {
            disType = 'MC';
        }

        let obj: any = SafeJSON.get('adjudicationDisposition.dispositions', this.json);

        for (const temp of obj) {
            disType = SafeJSON.get('dispositionType', temp);
            break;
        }

        switch (disType) {
            case 'U': return disType;
            case 'DDO': return disType;
            case 'MC': return disType;
            default: return 'D';
        }
    }

    populateAllegationResult() {
        let dispositionDate: string = SafeJSON.get('dispositionDate', this.json);
        let caseIssueId: string = SafeJSON.get('caseIssueId', this.json);
        let obj: any = SafeJSON.get('adjudicationDisposition.adjudicationDelinquentOrder', this.json);
        if (obj !== '') {
            this.allegationResult = new AllegationResult(obj, caseIssueId);
        }
    }

    populateAllegationUndisciplined() {
        let caseIssueId: string = SafeJSON.get('caseIssueId', this.json);
        let obj: any = SafeJSON.get('adjudicationDisposition.adjudicationUndisciplinedOrder', this.json);
        if (obj !== '') {
            this.allegationUndisciplined = new AllegationUndisciplined(obj, caseIssueId);
        }
    }

    populateAllegationContemptMotion() {
        let adjudicationObj: any = SafeJSON.get('adjudication.adjudicationEoDate', this.json);

        if (adjudicationObj !== '' || this.getAdjudicationDate() !== '') {
            this.allegationContemptMotion = new ContemptMotion(adjudicationObj, this.getAdjudicationDate(), null);
        }
    }

    populateDispositionContemptMotion() {
        let dispositionObj: any = SafeJSON.get('disposition.dispositionEoDate', this.json);

        if (dispositionObj !== '' || this.getDispositionDate() !== '') {
            this.dispositionContemptMotion = new ContemptMotion(dispositionObj, null, this.getDispositionDate());
        }
    }

    populateDispositionResult() {
        let caseIssueId: string = SafeJSON.get('caseIssueId', this.json);
        let obj: any = SafeJSON.get('adjudicationDisposition.dispositionDelinquentOrder', this.json);
        if (obj !== '') {
            this.dispositionResult = new DispositionResult(obj, caseIssueId);
        }
    }

    populateDispositionDelinquentOffense() {
        let caseIssueId: string = SafeJSON.get('caseIssueId', this.json);
        let obj: any = SafeJSON.get('adjudicationDisposition.dispositionLevelThreeDelinquentOrder', this.json);
        if (obj !== '') {
            this.dispositionDelinquentOffense = new DispositionDelinquentOffense(obj, caseIssueId);
        }
    }

    populateDispositionUndisciplined() {
        let caseIssueId: string = SafeJSON.get('caseIssueId', this.json);
        let obj: any = SafeJSON.get('adjudicationDisposition.dispositionUndisciplinedOrder', this.json);
        if (obj !== '') {
            this.dispositionUndisciplined = new DispositionUndisciplined(obj, caseIssueId);
        }
    }

    populateRelatedPartyList() {
        let obj: any = SafeJSON.get('issuePartyList', this.json);
        let index = '0';
        for (const issue of obj) {
            let value = new RelatedParty(issue, index);
            this.relatedParties.push(value);
        }
    }

    populateProbationConditons() {
        let caseIssueId: string = SafeJSON.get('caseIssueId', this.json);
        let obj: any = SafeJSON.get('adjudicationDisposition.suppProbationConditionOrder', this.json);
        if (obj !== '') {
            this.probationCondition = new ProbationCondition(obj, caseIssueId);
        }
    }

    populateSupplementalDispositions() {
        let caseIssueId: string = SafeJSON.get('caseIssueId', this.json);
        let obj: any = SafeJSON.get('adjudicationDisposition.suppDelinquentOrderList', this.json);

        for (const spplDispn of obj) {
            let value = new SupplementalDisposition(spplDispn, caseIssueId);
            this.supplementalDispositions.push(value);
        }
    }

    populateRelatedEvents() {
        let obj: any = SafeJSON.get('eventList', this.json);
        let index = '0';
        for (const relatedEvent of obj) {
            let value = new RelatedEvent(relatedEvent);
            this.relatedEvents.push(value);
        }
    }

    getAllegationResult(): AllegationResult {
        return this.allegationResult;
    }

    getAllegationUndisciplined(): AllegationUndisciplined {
        return this.allegationUndisciplined;
    }

    getAllegationContemptMotion(): ContemptMotion {
        return this.allegationContemptMotion;
    }

    getDispositionContemptMotion(): ContemptMotion {
        return this.dispositionContemptMotion;
    }

    getProbationCondition(): ProbationCondition {
        return this.probationCondition;
    }

    getSupplementalDispositions(): any[] {
        return this.supplementalDispositions;
    }

    getRelatedEvents(): any[] {
        this.relatedEvents.sort(function (event1, event2) {
            let time1 = '00:00 AM';
            let time2 = '00:00 AM';

            if (event1.getTime() !== undefined) {
                time1 = event1.getTime() ? event1.getTime() : time1;
            }

            if (event2.getTime() !== undefined) {
                time2 = event2.getTime() ? event2.getTime() : time2;
            }

            const date1 = new Date(moment(event1.getDate(), 'YYYY-MM-DD').format('MM/DD/YYYY') + ' ' + time1);
            const date2 = new Date(moment(event2.getDate(), 'YYYY-MM-DD').format('MM/DD/YYYY') + ' ' + time2);
            // Sort by Date and Time
            return (date2.getTime() - date1.getTime());
        });
        return this.relatedEvents;
    }

    getDispositionResult(): DispositionResult {
        return this.dispositionResult;
    }

    getDispositionDelinquentOffense(): DispositionDelinquentOffense {
        return this.dispositionDelinquentOffense;
    }

    getDispositionUndisciplined(): DispositionUndisciplined {
        return this.dispositionUndisciplined;
    }

    getPleadingDate(): string {
        return SafeJSON.get('juvenilePleading.pleadingDate', this.json);
    }

    getPleadingTime(): string {
        return SafeJSON.get('juvenilePleading.pleadingTime', this.json);
    }

    getPleadingType(): string {
        return SafeJSON.get('juvenilePleading.pleadingType', this.json);
    }

    getPleadingTypeCode(): string {
        return SafeJSON.get('juvenilePleading.pleadingTypeCode', this.json);
    }

    getPleadingTypeDesc(): string {
        return SafeJSON.get('juvenilePleading.pleadingTypeDesc', this.json);
    }

    getAdjudicationDate(): string {
        return SafeJSON.get('closedDate', this.json);
    }

    getDispositionDate(): string {
        return SafeJSON.get('dispositionDate', this.json);
    }

    getAllegationDescription(): string {
        return SafeJSON.get('description', this.json);
    }

    getAllegationOffenseDate(): string {
        return SafeJSON.get('initDate', this.json);
    }

    getOffenseDate(): string {
        return SafeJSON.get('offenseDate', this.json);
    }

    getAllegationOffenseTime(): string {
        return SafeJSON.get('dispTimestamp', this.json);
    }

    getAdjResult(): string {
        return SafeJSON.get('methodOfAdjDesc', this.json);
    }

    getDispResult(): string {
        return SafeJSON.get('methodOfDispDesc', this.json);
    }

    getAmdAllDesc(): string {
        return SafeJSON.get('amdAllDesc', this.json);
    }

    getReceivingCountyName(): string {
        return SafeJSON.get('juvenilePleading.receivingCountyName', this.json);
    }

    getTransferFromCase(): string {
        return SafeJSON.get('fromJuvenilePleading.transferFromCase', this.json);
    }

    getTransferFromCounty(): string {
        return SafeJSON.get('fromJuvenilePleading.transferFromCounty', this.json);
    }

    getNotes(): string {
        return SafeJSON.get('notes', this.json);
    }

    normalizeCaseNumber(caseNumber: string): string {
        if (!caseNumber || caseNumber.trim() === '') {
            return '';
        }

        // removed the white spaces
        caseNumber = caseNumber.replace(/\s/g, '');
        caseNumber = caseNumber.substr(2, caseNumber.length);
        return caseNumber;
    }

    getChangeVenue(): string {
        let changeVenue = '';

        if ((this.getTransfrdCounty() !== undefined && this.getTransfrdCounty() !== '')
            || (this.getTransfrdCase() !== undefined && this.getTransfrdCase() !== '')
            || (this.getTransfrdDate() !== undefined && this.getTransfrdDate() !== '')
            || (this.getTransfrdTime() !== undefined && this.getTransfrdTime() !== '')) {
            // tslint:disable-next-line:quotemark
            changeVenue = changeVenue + "<div class='popover-section'><B><U>From Case</B></U></div>";
            // tslint:disable-next-line:quotemark
            changeVenue = changeVenue + "<div class='popover-section'>" + this.getTransfrdCounty() +
            '&nbsp;&nbsp;' + this.normalizeCaseNumber(this.getTransfrdCase()) + '</div>';
            // tslint:disable-next-line:quotemark
            changeVenue = changeVenue + "<br><div class='popover-section'><B><U>Petition Clock Date</B></U></div>";
            // tslint:disable-next-line:quotemark
            changeVenue = changeVenue + "<div class='popover-section'>" + this.getFormattedTransfrdDate() +
            '&nbsp;&nbsp;' + this.getTransfrdTime() + '</div>'
        }

        return changeVenue.trim();
    }

    getFormattedTransfrdDate(): string {
        if (this.getTransfrdDate() !== '') {
            let val: string[] = this.getTransfrdDate().split('-');
            return (val[1] + '/' + val[2] + '/' + val[0]);
        }
        return '';
    }

    getRelatedParties(): any[] {
        // Sort this list by last name (note: this sorting requires a user defined object)
        this.relatedParties.sort(function (name1, name2) {
            const date1 = new Date(name1.getServiceDate());
            const date2 = new Date(name2.getServiceDate());

            // Sort by Date
            let flag: number = date2.getUTCDate() - date1.getUTCDate();

            if (flag === 0) {
                // Sort by Party Name
                if ((name1.getPartyName() < name2.getPartyName())) {
                    return -1;
                } else if ((name1.getPartyName() > name2.getPartyName())) {
                    return 1;
                } else {
                    // Sort by Party Type
                    if ((name1.getPartyType() < name2.getPartyType())) {
                        return -1;
                    } else if ((name1.getPartyType() > name2.getPartyType())) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            } else {
                return flag;
            }
        });

        return this.relatedParties;
    }

    showAllegations(panelName: string): void {
        switch (panelName) {
            case 'ALLEGATION_RESULT':
                this.allegationResultFlag = true;
                this.dispositionResultFlag = false;
                this.supplDispositionFlag = false;
                this.probationConditionFlag = false;
                this.relatedEventsFlag = false;
                this.relatedPartiesFlag = false;
                break;
            case 'DISPOSITION_RESULT':
                this.allegationResultFlag = false;
                this.dispositionResultFlag = true;
                this.supplDispositionFlag = false;
                this.probationConditionFlag = false;
                this.relatedEventsFlag = false;
                this.relatedPartiesFlag = false;
                break;
            case 'SUPPL_DISPOSITION':
                this.allegationResultFlag = false;
                this.dispositionResultFlag = false;
                this.supplDispositionFlag = true;
                this.probationConditionFlag = false;
                this.relatedEventsFlag = false;
                this.relatedPartiesFlag = false;
                break;
            case 'PROBN_CONDN':
                this.allegationResultFlag = false;
                this.dispositionResultFlag = false;
                this.supplDispositionFlag = false;
                this.probationConditionFlag = true;
                this.relatedEventsFlag = false;
                this.relatedPartiesFlag = false;
                break;
            case 'RLTD_EVNTS':
                this.allegationResultFlag = false;
                this.dispositionResultFlag = false;
                this.supplDispositionFlag = false;
                this.probationConditionFlag = false;
                this.relatedEventsFlag = true;
                this.relatedPartiesFlag = false;
                break;
            case 'RLTD_PRTS':
                this.allegationResultFlag = false;
                this.dispositionResultFlag = false;
                this.supplDispositionFlag = false;
                this.probationConditionFlag = false;
                this.relatedEventsFlag = false;
                this.relatedPartiesFlag = true;
                break;
        }
    }

    showAllegationResults(): boolean {
        return this.allegationResultFlag;
    }

    showDispostionResult(): boolean {
        return this.dispositionResultFlag;
    }

    showSupplementalDisposition(): boolean {
        return this.supplDispositionFlag;
    }

    showProbationCondition(): boolean {
        return this.probationConditionFlag;
    }

    showReleatedEvents(): boolean {
        return this.relatedEventsFlag;
    }

    showRelatedParties(): boolean {
        return this.relatedPartiesFlag;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/allegations.ts